import { render } from "./SearchCheckboxComponent.vue?vue&type=template&id=2b30b04d&scoped=true"
import script from "./SearchCheckboxComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchCheckboxComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchCheckboxComponent.vue?vue&type=style&index=0&id=2b30b04d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b30b04d"]])

export default __exports__